document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-product-root]').forEach(function(root){
    var select=root.querySelector('[data-variant-select]');
    var price=root.querySelector('[data-product-price]');
    var status=root.querySelector('[data-product-status]');
    var button=root.querySelector('[data-add-button]');
    var mainImage=root.querySelector('[data-product-main-image]');
    if(select){select.addEventListener('change',function(){
      var option=select.options[select.selectedIndex];
      if(price&&option.dataset.price) price.textContent=option.dataset.price;
      var available=option.dataset.available==='true';
      if(button){button.disabled=!available; button.textContent=available?(button.dataset.addText||button.textContent):(button.dataset.soldText||button.textContent);}
      if(status) status.textContent=available?(root.dataset.availableText||status.textContent):(root.dataset.unavailableText||status.textContent);
      if(mainImage&&option.dataset.image) mainImage.src=option.dataset.image;
    });}
    root.querySelectorAll('[data-image-src]').forEach(function(thumb){thumb.addEventListener('click',function(){if(mainImage) mainImage.src=thumb.dataset.imageSrc;});});
  });
});
